import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import BaseCommand from './BaseCommand';
import { saveConfigs, saveContentConfigs } from '../../redux/config/config.slice';
import { saveCartInfo } from '../../redux/cart/cart.slice';
import { DropInPaymentsCommandNames, StatusTypes, Component, ContextType, SharedCommandNames, fireStatusUpdate, Namespace } from '@chegg/commerce-utils';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
export var REPLACE_ITEM_ERROR_MESSAGE = 'Replace item in cart failed.';
export var ReplaceItemCommand = /*#__PURE__*/function (_BaseCommand) {
  function ReplaceItemCommand() {
    _classCallCheck(this, ReplaceItemCommand);
    return _callSuper(this, ReplaceItemCommand, arguments);
  }
  _inherits(ReplaceItemCommand, _BaseCommand);
  return _createClass(ReplaceItemCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _updateResponse$data, _updateResponse$data2, _updateResponse$data3, _updateResponse$data4, _updateResponse$data5, _updateResponse$data6, _updateResponse$data7;
        var updateResponse, success, errors, _ref, isEligible, code, _updateResponse$data$, total, subtotal, currencyName;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.client.cartAPI.updateCart(this.state.cart.cartId, this.input.data.itemData, undefined, this.input.data.hostAnnotations, false);
            case 2:
              updateResponse = _context.sent;
              success = updateResponse.success, errors = updateResponse.errors;
              if (!(!success && errors)) {
                _context.next = 8;
                break;
              }
              sendNewRelicMessage(REPLACE_ITEM_ERROR_MESSAGE, {
                errors: JSON.stringify(updateResponse.errors[0])
              });
              this.callbackErrorsToHost(updateResponse.errors, DropInPaymentsCommandNames.REPLACE_ITEM);
              return _context.abrupt("return");
            case 8:
              // check if replacing item was success and returned back a mix cart merged coupon; which we need to display in coupon component
              // also set that this is a verified coupon and don't need to call addCopuon logic again to this verifed merged coupon cart.
              if ((_updateResponse$data = updateResponse.data) !== null && _updateResponse$data !== void 0 && _updateResponse$data.coupon) {
                _ref = updateResponse.data.coupon, isEligible = _ref.isEligible, code = _ref.code;
                if (isEligible && code && code.length > 0) {
                  this.dispatch(saveConfigs({
                    couponCode: code,
                    isCouponVerified: true
                  }));
                  this.dispatch(saveCartInfo({
                    orderSummary: updateResponse.data.orderSummary
                  }));
                }
              }
              if ((_updateResponse$data2 = updateResponse.data) !== null && _updateResponse$data2 !== void 0 && _updateResponse$data2.orderSummary) {
                _updateResponse$data$ = updateResponse.data.orderSummary, total = _updateResponse$data$.total, subtotal = _updateResponse$data$.subtotal, currencyName = _updateResponse$data$.currencyName;
                this.dispatch(savePaymentMethodsCommands([{
                  commandName: SharedCommandNames.UPDATE_PRICING,
                  data: {
                    total: total,
                    subtotal: subtotal,
                    currency: currencyName
                  }
                }]));
              }
              if (this.input.data.orderSummaryContent) {
                this.dispatch(saveContentConfigs({
                  orderSummaryContent: this.input.data.orderSummaryContent
                }));
              }
              this.dispatch(saveCartInfo({
                cartId: (_updateResponse$data3 = updateResponse.data) === null || _updateResponse$data3 === void 0 ? void 0 : _updateResponse$data3.cartId,
                items: this.input.data.itemData,
                externalId: (_updateResponse$data4 = updateResponse.data) === null || _updateResponse$data4 === void 0 ? void 0 : _updateResponse$data4.items[0].externalId,
                subtotalWithCurrencyFormat: ((_updateResponse$data5 = updateResponse.data) === null || _updateResponse$data5 === void 0 ? void 0 : _updateResponse$data5.orderSummary.subtotalWithCurrencyFormat) || undefined,
                taxInfo: this.input.data.taxInfo || this.state.cart.taxInfo // we don't want to overwrite tax if not sent
              }));

              fireStatusUpdate([{
                status: StatusTypes.SUCCESS,
                command: DropInPaymentsCommandNames.REPLACE_ITEM,
                payload: {
                  component: Component.COMMAND_MANAGER,
                  context: ContextType.DROP_IN_PAYMENTS,
                  data: {
                    cartId: (_updateResponse$data6 = updateResponse.data) === null || _updateResponse$data6 === void 0 ? void 0 : _updateResponse$data6.cartId,
                    orderSummary: (_updateResponse$data7 = updateResponse.data) === null || _updateResponse$data7 === void 0 ? void 0 : _updateResponse$data7.orderSummary
                  }
                }
              }], Namespace.DROP_IN_PAYMENTS);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/ReplaceItemCommand.js
// module id = 4694
// module chunks = 11